import { CustomElement } from '@aurelia/runtime-html';
export const name = "number-input";
export const template = "<template>\n    <input value.bind=\"value\" class=\"form-control text-right\" maxlength.bind=\"maxlength\" placeholder.bind=\"placeholder\"\n        tabindex.bind=\"tabindex\" ref=\"input\"></textarea>\n</template>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
